import { http, HttpResponse, type HttpHandler } from "msw";
import { apiPaths } from "../../api-paths.js";
import type {
  Authentication_AuthenticateWithOauth_AuthenticateWithOauthCommandResponse_Success,
  Authentication_LoginByEmail_LoginByEmailCommandResponse_Success,
} from "../../swagger-types/v1/index.js";

const createLogoutHandler = (onRequest?: (request: Request) => void): HttpHandler[] => [
  http.post(`**${apiPaths.authentication.logout}`, ({ request }) => {
    onRequest?.(request);
    return HttpResponse.json({}, { status: 200 });
  }),
];

const createLoginByEmailHandler = (
  response: Authentication_LoginByEmail_LoginByEmailCommandResponse_Success = {
    accessToken: "FAKE_ACCESS_TOKEN_FOR_TEST_MOCKS_DO_NOT_USE",
    user: {
      id: 123,
      email: "test@test.pl",
      username: "test@test.pl",
      phone: null,
    },
  },
): HttpHandler[] => [
  http.post(`**${apiPaths.authentication.byEmail}`, () => {
    return HttpResponse.json(response, { status: 200 });
  }),
];

const createOauthHandler = (
  response: Authentication_AuthenticateWithOauth_AuthenticateWithOauthCommandResponse_Success = {
    accessToken: "FAKE_OAUTH_ACCESS_TOKEN_FOR_TEST_MOCKS_DO_NOT_USE",
    user: {
      id: 123,
      email: "oauth-user@test.pl",
      username: "oauth-user@test.pl",
      phone: {
        callingCode: "48",
        countryCode: "PL",
        phoneNumber: "123456789",
      },
    },
  },
  onRequest?: (request: Request) => void,
): HttpHandler[] => [
  http.post(`**${apiPaths.authentication.oauth}`, ({ request }) => {
    onRequest?.(request);
    return HttpResponse.json(response, { status: 200 });
  }),
];

export const authenticationHandlersFactories = {
  loginByEmail: createLoginByEmailHandler,
  oauth: createOauthHandler,
  logout: createLogoutHandler,
} as const;

export const authenticationHandlers = {
  loginByEmail: authenticationHandlersFactories.loginByEmail(),
  oauth: authenticationHandlersFactories.oauth(),
  loginByPhoneVerification: [
    http.post(`**${apiPaths.authentication.byPhone}`, () => {
      return HttpResponse.json(
        {
          accessToken:
            "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIyMDAwMzkzIiwianRpIjoiNzZlNzNjOGUtY2IzMS00NWQ2LWFjYjItNTBlMjJkNzZkYWQ4IiwiYnJhbmRfaWQiOiI2IiwibmJmIjoxNzU5MzExMDU0LCJleHAiOjE3NTk5MTU4NTQsImlhdCI6MTc1OTMxMTA1NH0.I6hf1XA1GXASV2S7nGKg2GKKfRKg8I0GIJ03hSVc-wQ",
        },
        { status: 200 },
      );
    }),
  ],
  logout: authenticationHandlersFactories.logout(),
} satisfies Record<string, HttpHandler[]>;
